module.exports = __webpack_public_path__ + "img/9-weatherpump2.1da68d18.png";